import loadable from '@loadable/component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { selectIsOfferRedesignExperimentActive } from 'shared/selectors/abExperiments';
import { isRentDailySelector } from 'shared/selectors/isRentDaily';
import { isCommercialSelector } from 'shared/selectors/offerData/offer/isCommercialSelector';
import { isNewbuildingFromDeveloperSelector } from 'shared/selectors/offerData/offer/isNewbuildingFromDeveloperSelector';
import { selectIsOfferPageCommercialRedesignSelector } from 'shared/selectors/selectIsOfferPageCommercialRedesign';
import { isSuburbanSelector } from 'shared/selectors/suburban/isSuburbanSelector';

export const OfferCardPageContainerLoadable = loadable(() => import('../../components/offer_card_page/container'));
const NewbuildingPageContainerLoadable = loadable(
  () => import('shared/containers/NewbuildingPageContainer/NewbuildingPageContainer'),
);
const CommercialPageContainerLoadable = loadable(
  () => import('shared/containers/CommercialPageContainer/CommercialPageContainer'),
);
const SuburbanPageContainerLoadable = loadable(
  () => import('shared/containers/SuburbanPageContainer/SuburbanPageContainer'),
);
const DailyRentPageContainerLoadable = loadable(
  () => import('shared/containers/DailyRentPageContainer/DailyRentPageContainer'),
);
const FlatPageContainerLoadable = loadable(() => import('shared/containers/FlatPageContainer/FlatPageContainer'));
export const CommercialOfferCardPageContainerLoadable = loadable(
  () => import('../../components/offer_card_page.commercial/container'),
);

export const PageContainer = () => {
  const context = useApplicationContext();
  const isRedesign = useSelector(selectIsOfferRedesignExperimentActive);
  const isRedesignForCommercial = useSelector(selectIsOfferPageCommercialRedesignSelector);
  const isNewbuildingFromDeveloper = useSelector(isNewbuildingFromDeveloperSelector);
  const isCommercial = useSelector(isCommercialSelector);
  const isRentDaily = useSelector(isRentDailySelector);
  const isSuburban = useSelector(isSuburbanSelector);

  if (isCommercial && !isRedesignForCommercial) {
    return <CommercialOfferCardPageContainerLoadable context={context} />;
  }

  if (isCommercial && isRedesignForCommercial) {
    return <CommercialPageContainerLoadable />;
  }

  if (isNewbuildingFromDeveloper) {
    return <NewbuildingPageContainerLoadable />;
  }

  if (isRedesign && isRentDaily) {
    return <DailyRentPageContainerLoadable />;
  }

  if (isRedesign && isSuburban) {
    return <SuburbanPageContainerLoadable />;
  }

  if (isRedesign) {
    return <FlatPageContainerLoadable />;
  }

  return <OfferCardPageContainerLoadable context={context} />;
};
